import React, { useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';
import arrowIcon from '../assets/images/Arrow.svg';
import "../styles/dataTable.css";
import searchIcon from '../assets/images/search_icon.svg';
import editIcon from '../assets/images/edit_icon.svg';
import addIcon from '../assets/images/add-icon.svg'

const ManagePackage = () => {
  const navigate = useNavigate();
  const [cards, setCards] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [categories, setCategories] = useState([]);


  // Table state
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const filteredData = cards.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(search.toLowerCase())
  );

  if (sortField) {
    filteredData.sort((a, b) => {
      const valA = a[sortField];
      const valB = b[sortField];
      if (typeof valA === "number") {
        return sortOrder === "asc" ? valA - valB : valB - valA;
      } else {
        return sortOrder === "asc"
          ? String(valA).localeCompare(String(valB))
          : String(valB).localeCompare(String(valA));
      }
    });
  }

  const totalPages = Math.ceil(filteredData.length / entriesPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(1);
  }, [search, entriesPerPage, totalPages]);

  // Sort Toggle Handler
  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
    } else {
      setSortField(field);
      setSortOrder("asc");
    }
  };

  // Fetch API data
  useEffect(() => {
    fetchVendor();
    fetchCategory();
    fetchCards();
  }, []);

  const fetchVendor = async () => {
    try {
      const response = await api.get('/vendor/get-all');
      setVendors(response.data.data || []);
    } catch (error) {
      console.error('Error fetching Service Provider data:', error);
    }
  };

  const fetchCategory = async () => {
    try {
      const response = await api.get('/page/get-all');
      setCategories(response.data.data || []);
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const fetchCards = async () => {
    try {
      const response = await api.get('/product/get-all');
      setCards(response.data.data || []);
    } catch (error) {
      console.error('Error fetching card data:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/cards/${id}`);
      setCards(cards.filter(card => card.id !== id));
      alert(`Package with ID ${id} deleted successfully`);
    } catch (error) {
      console.error('Error deleting package:', error);
      alert('Error deleting package');
    }
  };

  const handleCreatePackageClick = () => {
    navigate('/manage-package/create');
  };

  const handlePackageUpdate = (id) => {
    navigate(`/manage-package/edit/${id}`);
  };

  return (
    <div style={{ position: 'relative', height:'auto', overflow: 'hidden' }}>
      <div style={{ padding: "20px", opacity:  1 }}>
        {/* Table Header */}
        <div className="table-header">
          <h2 style={{ fontWeight: 700 }}>Manage Package</h2>

          <div className="search-container">
            <input
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1);
              }}
              placeholder="search"
            />
            <img src={searchIcon} alt="search-icon" className="search-icon" />
          </div>

          <div className="entries-container">
            <label htmlFor="noOfEntries">Show: </label>
            <select
              value={entriesPerPage}
              id="noOfEntries"
              onChange={(e) => setEntriesPerPage(Number(e.target.value))}
            >
              <option value={10}>10 Entries per page</option>
              <option value={50}>50 Entries per page</option>
              <option value={100}>100 Entries per page</option>
            </select>
          </div>

          <div className="action-btn">
              <button onClick={handleCreatePackageClick}>
                <img src={addIcon} alt="add-icon" />  Add Package
              </button>
          </div>

        </div>

        {/* Table */}
        <table width="100%" cellPadding="26" className="table-no-outer-border">
          <thead>
            <tr>
              <th onClick={() => handleSort("category_id")}>Pilgrimage Type</th>
              <th onClick={() => handleSort("packagename")}>Packagename</th>
              {/* <th onClick={() => handleSort("city")}>City</th> */}
              <th onClick={() => handleSort("duration")}>Duration</th>
              <th onClick={() => handleSort("price")}>Price</th>
              <th>Image</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData.length > 0 ? (
              paginatedData.map((card, i) => (
                <tr key={card.id}>
                  <td>{categories?.find(el => el.id === card.category_id)?.name || "N/A"}</td>
                  <td>{card.packagename}</td>
                  {/* <td>{card.city}</td> */}
                  <td>{card.duration}</td>
                  <td>₹ {parseFloat(card.price).toLocaleString('en-IN')}</td>
                  <td>
                    <img
                      style={{ width: '90px', borderRadius: '5px' }}
                      src={`${process.env.REACT_APP_IMAGE_BASE_URL}${card.image_path}`}
                      alt="banner"
                    />
                  </td>
                  <td>{card?.is_approved !== '1' ? "Pending" : "Approved"}</td>
                  <td className='text-center align-middle'>
                    <button className='edit-button' onClick={() => handlePackageUpdate(card.id)}>
                      <img src={editIcon} alt="editIcon" /> Edit
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} style={{ textAlign: "center" }}>No data found</td>
              </tr>
            )}
          </tbody>
        </table>

   {/* Pagination */}
<div style={{ paddingBottom: '30px', background: '#fff' }}>
  <div
    style={{
      padding: "30px",
      textAlign: "center",
      borderTop: '2px solid #F2F2F2',
      borderBottom: '2px solid #F2F2F2'
    }}
  >
    {/* Prev button */}
    <button
      onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      style={{
        margin: "0 5px",
        border: "none",
        background: "#fff",
        cursor: currentPage === 1 ? "not-allowed" : "pointer"
      }}
    >
      <img
        src={arrowIcon}
        alt="prev"
        style={{ opacity: currentPage === 1 ? 0.5 : 1 }}
      />
    </button>

    {/* Page numbers */}
    {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
      <button
        key={page}
        onClick={() => setCurrentPage(page)}
        style={{
          margin: "0 5px",
          padding: "5px 10px",
          background: currentPage === page ? "#D9D9D9" : "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: "pointer"
        }}
      >
        {page}
      </button>
    ))}

    {/* Next button */}
    <button
      onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
      disabled={currentPage === totalPages}
      style={{
        margin: "0 5px",
        border: "none",
        background: "#fff",
        cursor: currentPage === totalPages ? "not-allowed" : "pointer"
      }}
    >
      <img
        src={arrowIcon}
        alt="next"
        style={{
          opacity: currentPage === totalPages ? 0.5 : 1,
          transform: "rotateY(180deg)"
        }}
      />
    </button>
  </div>
</div>

      </div>

    </div>
  );
};

export default ManagePackage;
